<template>
    <div>
        <div class="container">
            <h2 class="postbox__title text--center">Tables</h2>

            <div class="game__statistics--content panel bg--layer-light pl--0 pr--0">
                <div class="game__result" v-if="users.length">
                    <table class="table">
                        <thead>
                        <tr>
                            <th scope="col" class="opacity--md text--center">#</th>
                            <th scope="col" class="opacity--md text--left">User</th>
                            <th scope="col" class="opacity--md text--center">Wins</th>
                            <th scope="col" class="opacity--md text--center">Points</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(userItem, index) in users" :class="[{'active': userItem.id === user.id}]">
                            <th scope="row">
                                <div class="sequence"><span>{{ index + 1 }}</span></div>
                            </th>
                            <td>
                                <router-link :to="{ name: 'user-profile', params: { id: userItem.id }}">
                                    <div class="profile profile--inline profile--horizontal">
                                        <figure class="profile__avatar"><span
                                            class="profile__avatar__img"><img
                                            :src="userItem.avatar" alt=""></span></figure>
                                        <div class="profile__text weight--bold">{{ userItem.nick }}</div>
                                    </div>
                                </router-link>
                            </td>
                            <td class="text--center">{{ userItem.wins || 0 }}</td>
                            <td class="text--center">{{ userItem.xp_points || 0 }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "../../api/toplist";
import {mapGetters} from "vuex";

export default {
    name: "DashboardToplist",

    data: function () {
        return {
            users: [],
        }
    },

    methods: {
        async loadUsers() {
            try {
                let response = await api.users()
                this.users = response.data
            } catch (e) {
                Quiz.$emit('toplist-users-load-error')
            }
        }
    },

    computed: {
        ...mapGetters('auth', [
            'user',
        ]),
    },

    created() {
        this.loadUsers()
    }
}
</script>

<style scoped>

</style>